// extracted by mini-css-extract-plugin
export default {"root":"dutnTKN0","segment":"nJglb69I","buy":"jhm4_ojH","sell":"qbbH_etK","value":"mD3X6FM2"};